'use strict';

function Theme(application) {
  this.application = application || 'EEN';
  this.mapping = {
    EEN: 'een',
    PRONET: 'pronet',
    CAPTURE: 'capture',
    WISENET: 'wisenet',
    HKT: 'hkt',
    MOBOTIX: 'mobotix',
    BOSCH: 'bosch',
  };

  this.defaultColors = {
    //Fixed colors
    primary: '#252932',
    primaryMedium: '#2F3644',
    primaryLight: '#475268',
    primaryWhite: '#FFFFFF',
    secondary: '#606E81',
    secondaryMedium: '#8F9CAC',
    secondaryLight: '#BEC9D6',
    secondaryDark: '#999999',
    elements: '#E3E9EF',
    backgrounds: '#F3F7FB',
    analytics: '#C0DF16',
    accentFixed: '#0091da',
    accentDarkFixed: '#0067AC',

    //Action Colors
    positive: '#1fb67f',
    positiveDark: '#009660',
    positiveLight: '#A8E8D0',
    positiveClear: '#e7fff6',

    warning: '#E9B600',
    warningDark: '#d3a500',
    warningLight: '#F6E7B3',
    warningClear: '#fff9e4',

    negative: '#ee5361',
    negativeDark: '#d0404d',
    negativeLight: '#FFBFC6',
    negativeClear: '#fdeaec',

    //camera settings color
    configurationBlue: '#6ECFF6',
    configurationPink: '#F49AC2',
    configurationOrange: '#FDC68A',
    configurationViolet: '#BC8DBF',
    configurationYellow: '#FFF79A',
    configurationGreen: '#82CA9D',
  };

  this.themes = {
    een: {
      colors: {
        accent: '#0091da',
        accentDark: '#0067AC',
        accentLight: '#C6E6FF',
        accentClear: '#E5F4FF',
      },
      companyName: 'Eagle Eye Networks',
      favicon: 'favicon.ico',
    },
    pronet: {
      colors: {
        accent: '#E47330',
        accentDark: '#C14F1E',
        accentLight: '#FFCAAA',
        accentClear: '#FFF2EA',
      },
      companyName: 'ProNet',
      favicon: 'favicon-pronet.ico',
    },
    capture: {
      colors: {
        accent: '#0C94C8',
        accentDark: '#00739E',
        accentLight: '#B4E9FE',
        accentClear: '#ECFAFF',
      },
      companyName: 'Capture',
      favicon: 'favicon-capture.ico',
    },
    wisenet: {
      colors: {
        accent: '#F37321',
        accentDark: '#B85901',
        accentLight: '#FFE2C7',
        accentClear: '#FFF7F0',
      },
      companyName: 'Wisenet',
      favicon: 'favicon-wisenet.ico',
    },
    hkt: {
      colors: {
        accent: '#3989C4',
        accentDark: '#256899',
        accentLight: 'BBE2FF',
        accentClear: '#E9F6FF',
      },
      companyName: 'HKT',
      favicon: 'favicon-hkt.ico',
    },
    mobotix: {
      colors: {
        accent: '#004594',
        accentDark: '#0E2B55',
        accentLight: '#B4D7FB',
        accentClear: '#E2F0FE',
      },
      companyName: 'Mobotix',
      favicon: 'favicon-mobotix.ico',
    },
    bosch: {
      colors: {
        accent: '#007BC0',
        accentDark: '#005F95',
        accentLight: '#B9E5FF',
        accentClear: '#EFF9FF',
      },
      companyName: 'Bosch',
      favicon: 'favicon-bosch.ico',
    },
  };
}

Theme.prototype.colors = function () {
  const mapping = this.mapping[this.application] ? this.mapping[this.application] : 'een';
  const colors = {
    ...this.defaultColors,
    ...(this.themes[mapping] ? this.themes[mapping].colors : this.themes.een.colors),
  };
  return { themes: { light: colors }, options: { customProperties: true } };
};

Theme.prototype.logo = function (type = '') {
  const mapping = this.mapping[this.application] ? this.mapping[this.application] : 'een';
  return this.themes[mapping]
    ? this.themes[mapping][`logo${type}`]
      ? this.themes[mapping][`logo${type}`]
      : null
    : null;
};

Theme.prototype.favicon = function (type = '') {
  const mapping = this.mapping[this.application] ? this.mapping[this.application] : 'een';
  return this.themes[mapping]
    ? this.themes[mapping][`favicon${type}`]
      ? this.themes[mapping][`favicon${type}`]
      : null
    : null;
};

Theme.prototype.logoHeight = function (type = '') {
  const mapping = this.mapping[this.application] ? this.mapping[this.application] : 'een';
  return this.themes[mapping]
    ? this.themes[mapping][`logoHeight${type}`]
      ? this.themes[mapping][`logoHeight${type}`]
      : null
    : null;
};

Theme.prototype.logoWidth = function (type = '') {
  const mapping = this.mapping[this.application] ? this.mapping[this.application] : 'een';
  return this.themes[mapping]
    ? this.themes[mapping][`logoWidth${type}`]
      ? this.themes[mapping][`logoWidth${type}`]
      : null
    : null;
};

Theme.prototype.companyName = function (type = '') {
  const mapping = this.mapping[this.application] ? this.mapping[this.application] : 'een';
  return this.themes[mapping]
    ? this.themes[mapping][`companyName${type}`]
      ? this.themes[mapping][`companyName${type}`]
      : null
    : null;
};
Theme.prototype.links = function (type = '') {
  const mapping = this.mapping[this.application] ? this.mapping[this.application] : 'een';
  return this.themes[mapping]
    ? this.themes[mapping][`links${type}`]
      ? this.themes[mapping][`links${type}`]
      : null
    : null;
};

export default Theme;
